import { connect } from "react-redux";
import DateTimeSettings from "./DateTimeSettings";
import {
  getDateFormat,
  updateDateFormat,
  updateStartDayOfWeek,
} from "./dateTimeSettingsActions";

const mapStateToProps = (state) => ({
  isLoading: state.dateTimeSettings.isLoading,
  selectedOrganization: state.organization.selectedOrganization,
  isDateFormatUpdated: state.dateTimeSettings.isDateFormatUpdated,
  dateFormat: state.dateTimeSettings.dateFormat,
  startDayOfWeek: state.dateTimeSettings.startDayOfWeek,
});

const mapDispatchToProps = (dispatch) => ({
  getDateFormat: (payload) => dispatch(getDateFormat(payload)),
  updateDateFormat: (payload) => dispatch(updateDateFormat(payload)),
  updateStartDayOfWeek: (payload) => dispatch(updateStartDayOfWeek(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DateTimeSettings);
